import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, Info } from "lucide-react";
import { Button } from "../components/ui/button";

const VerifyEmail = () => {
  const { token } = useParams();
  const [status, setStatus] = useState("loading"); // loading, success, already_verified, error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/verify-email/${token}`
        );
        const result = await response.json();

        if (response.ok && result.success) {
          if (result.already_verified) {
            setStatus("already_verified");
            setMessage("Este email ya ha sido verificado anteriormente.");
          } else {
            setStatus("success");
            setMessage("Tu email ha sido verificado correctamente.");
          }
        } else {
          setStatus("error");
          if (result.detail === "token_expired") {
            setMessage("El enlace de verificación ha expirado.");
          } else if (result.detail === "already_verified") {
            setStatus("already_verified");
            setMessage("Este email ya ha sido verificado anteriormente.");
          } else {
            setMessage("El enlace de verificación no es válido.");
          }
        }
      } catch (error) {
        setStatus("error");
        setMessage("Error al verificar el email. Inténtalo de nuevo más tarde.");
      }
    };

    if (token) {
      verifyEmail();
    }
  }, [token]);

  const handleGoHome = () => {
    window.location.href = "https://www.bluteca.com";
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg border border-slate-200 p-8 max-w-md w-full text-center">
        <div className="mb-6">
          <img
            src="https://customer-assets.emergentagent.com/job_altas-demo/artifacts/tufzwqkc_bluteca_logo_no_bg.png"
            alt="Bluteca Logo"
            className="h-16 mx-auto"
          />
        </div>

        {status === "loading" && (
          <>
            <Loader2 className="w-16 h-16 text-blue-500 mx-auto mb-4 animate-spin" />
            <h2 className="text-xl font-semibold text-slate-800 mb-2">
              Verificando tu email...
            </h2>
            <p className="text-slate-600">Por favor, espera un momento.</p>
          </>
        )}

        {status === "success" && (
          <>
            <CheckCircle2 className="w-16 h-16 text-green-500 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-slate-800 mb-2">
              ¡Email verificado!
            </h2>
            <p className="text-slate-600 mb-6">{message}</p>
            <p className="text-slate-600 mb-6">
              Nuestro equipo revisará tu solicitud y te notificaremos por email 
              cuando tu cuenta esté activa.
            </p>
            <Button
              data-testid="verify-ok-btn"
              onClick={handleGoHome}
              className="bg-orange-500 hover:bg-orange-600 text-white"
            >
              OK
            </Button>
          </>
        )}

        {status === "already_verified" && (
          <>
            <Info className="w-16 h-16 text-blue-500 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-slate-800 mb-2">
              Email ya verificado
            </h2>
            <p className="text-slate-600 mb-6">{message}</p>
            <Button
              data-testid="verify-already-ok-btn"
              onClick={handleGoHome}
              className="bg-orange-500 hover:bg-orange-600 text-white"
            >
              OK
            </Button>
          </>
        )}

        {status === "error" && (
          <>
            <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-slate-800 mb-2">
              Error de verificación
            </h2>
            <p className="text-slate-600 mb-6">{message}</p>
            <Button
              data-testid="verify-error-ok-btn"
              onClick={handleGoHome}
              className="bg-orange-500 hover:bg-orange-600 text-white"
            >
              OK
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
